// extracted by mini-css-extract-plugin
export default {"container":"redirect_container__TNe5o","logo":"redirect_logo__A1DL+","text":"redirect_text__oRxN3"};